import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerUserClientMapProfile from "../../controller/custom/UserClientMapProfile";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPageUserClientMapProfile: React.FC = () => {
    // Variable
    const controllerUserClientMapProfile = new ControllerUserClientMapProfile(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerUserClientMapProfile.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerUserClientMapProfile.getSelectOption && controllerUserClientMapProfile.getValidationForm) {
        return (
            <div className="view_user_client_map_profile form" data-at_id="view_user_client_map_profile">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerUserClientMapProfile.getDataMain) {
                        html.push(
                            <div>
                                <div>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        html.push(
                                            <div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value disabled"
                                                        name="id"
                                                        label={controllerLocalization.getStorageMain.id}
                                                        defaultValue={controllerUserClientMapProfile.getDataMain.id || ""}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value date"
                                                        data-at_id="input_latest_update"
                                                        name="latest_update"
                                                        label={controllerLocalization.getStorageMain.latest_update}
                                                        value={
                                                            controllerUserClientMapProfile.getDataMain.latest_update
                                                                ? HelperSrc.localeFormat(
                                                                      new Date(controllerUserClientMapProfile.getDataMain.latest_update)
                                                                  )
                                                                : ""
                                                        }
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                                <div className="field_container">
                                                    <MuiTextField
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_latest_update_by_id"
                                                        name="latest_update_by_id"
                                                        label={controllerLocalization.getStorageMain.latest_update_by}
                                                        defaultValue={(() => {
                                                            for (const optionData of Object.values(
                                                                controllerUserClientMapProfile.getSelectOption.user_id
                                                            )) {
                                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                                if (
                                                                    controllerUserClientMapProfile.getDataMain.latest_update_by_id ===
                                                                    optionDataTyped.value
                                                                ) {
                                                                    return optionDataTyped.display_name;
                                                                }
                                                            }
                                                        })()}
                                                        disabled
                                                    />
                                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                                </div>
                                            </div>
                                        );

                                        return html;
                                    })()}
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerUserClientMapProfile.getSelectOption.client_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerUserClientMapProfile.getElementClientIdValue === "" &&
                                                    controllerUserClientMapProfile.getDataMain
                                                        ? controllerUserClientMapProfile.getDataMain.client_id
                                                        : controllerUserClientMapProfile.getElementClientIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(
                                                        controllerUserClientMapProfile.getSelectOption.client_id
                                                    )) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_client_id"
                                                        required={
                                                            controllerUserClientMapProfile.getValidationForm
                                                                ? controllerUserClientMapProfile.getValidationForm.client_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => HelperSrc.checkRegexSelect(event.target.name, event.target.value)}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="client_id"
                                                        defaultValue={
                                                            controllerUserClientMapProfile.getElementClientIdValue === "" &&
                                                            controllerUserClientMapProfile.getDataMain
                                                                ? controllerUserClientMapProfile.getDataMain.client_id !== undefined
                                                                    ? controllerUserClientMapProfile.getDataMain.client_id
                                                                    : ""
                                                                : controllerUserClientMapProfile.getElementClientIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerUserClientMapProfile.setElementClientIdValue) {
                                                    controllerUserClientMapProfile.setElementClientIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(
                                                    controllerUserClientMapProfile.getSelectOption.invoice_role_id
                                                )) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerUserClientMapProfile.getElementInvoiceRoleIdValue === "" &&
                                                    controllerUserClientMapProfile.getDataMain
                                                        ? controllerUserClientMapProfile.getDataMain.invoice_role_id
                                                        : controllerUserClientMapProfile.getElementInvoiceRoleIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(
                                                        controllerUserClientMapProfile.getSelectOption.invoice_role_id
                                                    )) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_invoice_role_id"
                                                        required={
                                                            controllerUserClientMapProfile.getValidationForm
                                                                ? controllerUserClientMapProfile.getValidationForm.invoice_role_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => HelperSrc.checkRegexSelect(event.target.name, event.target.value)}
                                                        label={
                                                            controllerLocalization.getStorageMain
                                                                ? controllerLocalization.getStorageMain.invoice_role
                                                                : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="invoice_role_id"
                                                        defaultValue={
                                                            controllerUserClientMapProfile.getElementInvoiceRoleIdValue === "" &&
                                                            controllerUserClientMapProfile.getDataMain
                                                                ? controllerUserClientMapProfile.getDataMain.invoice_role_id !== undefined
                                                                    ? controllerUserClientMapProfile.getDataMain.invoice_role_id
                                                                    : ""
                                                                : controllerUserClientMapProfile.getElementInvoiceRoleIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerUserClientMapProfile.setElementInvoiceRoleIdValue) {
                                                    controllerUserClientMapProfile.setElementInvoiceRoleIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                    <div className="field_container">
                                        <MuiAutocomplete
                                            blurOnSelect
                                            options={(() => {
                                                const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                                for (const optionData of Object.values(controllerUserClientMapProfile.getSelectOption.user_id)) {
                                                    const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                    optionList.push(optionDataTyped);
                                                }

                                                return optionList;
                                            })()}
                                            getOptionLabel={(option) => option.display_name}
                                            value={(() => {
                                                const currentStr =
                                                    controllerUserClientMapProfile.getElementUserIdValue === "" &&
                                                    controllerUserClientMapProfile.getDataMain
                                                        ? controllerUserClientMapProfile.getDataMain.user_id
                                                        : controllerUserClientMapProfile.getElementUserIdValue;

                                                const opts = (() => {
                                                    const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];
                                                    for (const optionData of Object.values(controllerUserClientMapProfile.getSelectOption.user_id)) {
                                                        optionList.push(optionData as ModelHelperSrc.IelementOption);
                                                    }
                                                    return optionList;
                                                })();

                                                const selected = opts.find((o) => String(o.value) === String(currentStr)) || opts[0];
                                                return selected;
                                            })()}
                                            renderOption={(props, option) => {
                                                if (controllerLocalization.getStorageMain) {
                                                    return (
                                                        <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                            {option.display_name || controllerLocalization.getStorageMain.select}
                                                        </li>
                                                    );
                                                }
                                            }}
                                            isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                            renderInput={(params) => (
                                                <div>
                                                    <MuiTextField
                                                        {...params}
                                                        variant="outlined"
                                                        className="field_value"
                                                        data-at_id="input_user_id"
                                                        required={
                                                            controllerUserClientMapProfile.getValidationForm
                                                                ? controllerUserClientMapProfile.getValidationForm.user_id.required
                                                                : false
                                                        }
                                                        onChange={(event) => HelperSrc.checkRegexSelect(event.target.name, event.target.value)}
                                                        label={
                                                            controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.user : ""
                                                        }
                                                    />
                                                    <input
                                                        type="hidden"
                                                        className="field_value"
                                                        name="user_id"
                                                        defaultValue={
                                                            controllerUserClientMapProfile.getElementUserIdValue === "" &&
                                                            controllerUserClientMapProfile.getDataMain
                                                                ? controllerUserClientMapProfile.getDataMain.user_id !== undefined
                                                                    ? controllerUserClientMapProfile.getDataMain.user_id
                                                                    : ""
                                                                : controllerUserClientMapProfile.getElementUserIdValue
                                                        }
                                                    />
                                                </div>
                                            )}
                                            onChange={(_, option) => {
                                                if (option && controllerUserClientMapProfile.setElementUserIdValue) {
                                                    controllerUserClientMapProfile.setElementUserIdValue(option.value as string);
                                                }
                                            }}
                                        />
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </div>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_update"
                                            disabled={controllerUserClientMapProfile.getApiLoadingList.profileChange}
                                            onClick={(event) => {
                                                controllerUserClientMapProfile.clickChange(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerUserClientMapProfile.getApiLoadingList.profileChange) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.update}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageUserClientMapProfile;
